import i18next from "i18next";
import cloneDeep from "lodash/cloneDeep";

import { TreeModifier } from "@/components/InterventionTemplate/TreeModifier";
import { createRandomId } from "@/utilities/id";

export const cloneNodeAtLayoutIndex = ({ template, layoutIndex }) => {
  const updatedTemplate = cloneDeep(template);
  const predicate = (node) => node.layout_index == layoutIndex;

  const node = TreeModifier.find(updatedTemplate, "templates", predicate);
  const nodeParent = TreeModifier.findParentNode(
    updatedTemplate,
    "templates",
    predicate
  );

  const clonedNode = cloneNode(node);
  nodeParent.templates.push(clonedNode);

  return {
    updatedTemplate,
    newNodeId: clonedNode.layout_index,
  };
};

const cloneNode = (node) => {
  const nameSuffix = i18next.t("form:cloneSuffix");
  const name = `${node.name} ${nameSuffix}`;

  return assignNewLayoutIndexes({
    ...cloneDeep(node),
    name,
  });
};

const assignNewLayoutIndexes = (node) =>
  TreeModifier.deepReplace({
    node,
    name: "layout_index",
    replacer: createRandomId,
  });
